import React from "react";
import styled from "styled-components";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import {useHistory} from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import {Trans, useTranslation} from "react-i18next";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";

import {FormHelperText, makeStyles} from "@material-ui/core";
import Checkbox from "@material-ui/core/Checkbox";

const schema = yup.object().shape({
  code: yup.string(),
});

const Strong = styled.span`
  font-weight: 800;
`;

const useStylesAll = makeStyles((theme) => ({
  select: {
    width: "70px",
    height: "35px",
    marginTop: 0,
    marginBottom: "4px",
  },
  selectControl: {
    margin: 0,
    "& .Mui-disabled": {
      "& .MuiOutlinedInput-notchedOutline": {
        backgroundColor: "rgba(0, 0, 0, 0.06)",
      },
    },
    "& .MuiSelect-select": {
      "&:focus": {
        backgroundColor: "unset",
      },
    },
  },
  link: {
    color: "#962013",
    textDecoration: "underline",
  },
}));

const defaultFormValues = {
  code: "",
};

const placeholderValue = {};

function RegisterStep3Page(props) {
  const {currentStep, handleChange, gift, giftReady, shippingCostPickup, shippingCostDelivery, errorMessage, maxTicket} = props;

  const {t, i18n} = useTranslation("register");
  const classes = useStylesAll();
  const [onInit, setOnInit] = React.useState(true);
  const [totalQuota, setTotalQuota] = React.useState(0);
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [defaultValues, setDefaultValues] = React.useState(defaultFormValues);
  const [placeholder, setPlaceholder] = React.useState(placeholderValue);
  const history = useHistory();

  const {
    control,
  } = useForm({
    defaultValues: React.useMemo(() => defaultValues, [defaultValues]),
    resolver: yupResolver(schema),
  });

  function GiftList(props) {
    const {value, name, desc, maxT, disabled} = props;
    var rows = [];
    for (var i = 0; i <= maxT; i++) {
      rows.push(<option value={i}>{i}</option>);
    }
    ;
    return (
      <>
        <Grid item xs={3} sm={2} style={{maxWidth: "85px"}}>
          <FormControl
            variant="outlined"
            className={classes.selectControl}
            error={!!errorMessage.ticket}
          >
            <Select
              native
              value={value}
              onChange={handleChange}
              inputProps={{
                name: name,
              }}
              className={classes.select}
              disabled={disabled}
            >
              {/* <option aria-label="None" value=""/> */}
              {rows}

            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={9} sm={10}>
          {desc}
        </Grid>
      </>
    );
  }

  React.useEffect(function setVoucherQuotaOnInit() {
    if (onInit && giftReady) {
      Object.keys(gift).forEach(function (key) {
        if (gift[key]["quota"] && gift[key]["quota"] >= 0) {
          handleChange({target: {name: `gift-${gift[key]["id"]}`, value: gift[key]["quota"]}});
          setTotalQuota((prev) => prev + gift[key]["quota"]);
        }
      });
      setOnInit(false);
    }
  }, [onInit, gift, giftReady, handleChange])

  return currentStep == 3 ? (
    <>
      <Grid container spacing={1} alignItems="center">
        <Grid item xs={12} style={{marginTop: "15px"}}>
          <Typography variant="h2">
            <Trans t={t} i18nKey="selectgift" />
          </Typography>
          <Typography variant="p">
            {" "}
            <Trans t={t} i18nKey="totalticket">
              You can have <Strong> a total of {{maxTicket: maxTicket - 1}} ticket vouchers and 1 birthday voucher </Strong>
            </Trans>
          </Typography>
        </Grid>
        {Object.keys(gift).map(function (key) {
          if (key.includes("gift")) {
            return (
              <GiftList
                value={gift[key]["quantity"]}
                name={key}
                desc={gift[key]["name"]}
                maxT={maxTicket - totalQuota}
                disabled={gift[key]["quota"] && gift[key]["quota"] >= 0}
              />
            );
          }
        })}
        <FormHelperText style={{color: "red"}}>
          {errorMessage.ticket && t(errorMessage.ticket) + maxTicket}
        </FormHelperText>

        <Grid item xs={12}>
          <Typography variant="p">
            {t('eticketviaemail')}
          </Typography>
        </Grid>

        {/* <Grid item xs={12}>
          <FormControlLabel
            className={classes.label}
            control={
              <Checkbox
                id="receivePhysical"
                className={classes.checkbox}
                type="checkbox"
                color="primary"
                name="receivePhysical"
                checked={gift.deliveryMethod !== "2"}
                onChange={() => handleChange({
                  target: {
                    name: 'gift-deliveryMethod',
                    value: gift.deliveryMethod === "2" ? "0" : "2"
                  }
                })}
              />
            }
            label={`${t('receivephysical')} (+HK$${shippingCostPickup}) ${t('receivephysicalremark')}`}
          />
        </Grid> */}

        {/* {
          gift.deliveryMethod !== "2" && (
            <>
              <Grid item xs={12}>
                <Typography variant="h2">{t("pickuplocation")}</Typography>
              </Grid>

              <Grid item xs={12}>
                <FormControl
                  component="fieldset"
                  style={{width: "100%", marginTop: 0}}
                >
                  <RadioGroup
                    aria-label="deliveryMethod"
                    name="gift-deliveryMethod"
                    value={gift.deliveryMethod}
                    onChange={handleChange}
                  >
                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item xs sm={12}>
                        <FormControlLabel
                          value="0"
                          control={<Radio/>}
                          label={
                            <Trans t={t} i18nKey="selfpickup">
                              <a
                                className={classes.link}
                                target="_blank"
                                href="https://usercontent.hkiff.org.hk/hkiff/EC_Get_Pickup_Guide.pdf"
                              >
                                PackAge Pickup Guide
                              </a>
                            </Trans>}
                        />
                      </Grid>

                      {gift.deliveryMethod == "0" && (
                        <Grid
                          container
                          spacing={1}
                          alignItems="center"
                          style={{marginLeft: "27px"}}
                        >
                          <Grid item xs={12}>
                            <Typography variant="p">
                              <Trans t={t} i18nKey="ipostal">
                                <a
                                  className={classes.link}
                                  target="_blank"
                                  href={`https://www.hongkongpost.hk/${i18n.language}/about_us/network/ipostal_stations/index.html#list`}
                                >
                                  here
                                </a>
                              </Trans>
                              <Trans t={t} i18nKey="postoffice">
                                <a
                                  className={classes.link}
                                  target="_blank"
                                  href={`https://www.hongkongpost.hk/${i18n.language}/about_us/network/post_offices/index.html#list`}
                                >
                                  here
                                </a>
                              </Trans>
                            </Typography>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography variant="p">
                              <Trans t={t} i18nKey="pickupwithin48hr" components={[<Strong/>]}/>
                            </Typography>
                            <Controller
                              name="gift-pickupLocation"
                              control={control}
                              render={({field, fieldState: {error}}) => (
                                <>
                                  <TextField
                                    id="code"
                                    variant="outlined"
                                    margin="dense"
                                    className={classes.textInput}
                                    placeholder={t("codeplaceholder")}
                                    fullWidth
                                    {...field}
                                    error={!!errorMessage.pickupLocation}
                                    helperText={
                                      errorMessage.pickupLocation &&
                                      t(errorMessage.pickupLocation)
                                    }
                                    defaultValue={gift.pickupLocation}
                                    onChange={handleChange}
                                  />
                                </>
                              )}
                            />
                          </Grid>
                        </Grid>
                      )}
                    </Grid>

                    <Grid
                      container
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <Grid item xs={12}>
                        <FormControlLabel
                          value="1"
                          control={<Radio/>}
                          label={`${t("bypostalmail")} (+HK$${shippingCostDelivery - shippingCostPickup})`}
                        />
                      </Grid>

                      <Grid item xs={12} style={{marginLeft: "32px"}}>
                        <Typography variant="p">{t("postalmaildesc")}</Typography>
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </Grid>
            </>
          )
        } */}

      </Grid>
    </>
  ) : (
    <></>
  );
}

export default RegisterStep3Page;
